module.exports = __webpack_public_path__ + "assets/img/modal-avatar-5cc9c7ab.png";